import { AppName } from '../apps/definition';

interface PromptAuthor {
  display_name: string;
  email: string;
  icon: string;
}

export interface Prompt {
  id: string;
  title: string;
  description?: string;
  author: PromptAuthor;
  org_domain: string;
  default: boolean;
  visibility: 'PRIVATE' | 'PUBLIC';
  search_filters: AppName[];
  template: string;
  uses: number;
  created_at: number;
  modified_at: number;
}

export enum PromptModalTypes {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  DUPLICATE = 'DUPLICATE',
  VIEW_TEMPLATE = 'VIEW_TEMPLATE',
  VIEW_ALL_TEMPLATES = 'VIEW_ALL_TEMPLATES',
}
